export default "__VITE_ASSET__NY8hFosA__"